module.exports = __webpack_public_path__ + "img/product_1_2.9e154801.jpg";